import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DistributorLayout from '../layouts/DistributorLayout';
import { useAuth } from '../contexts/AuthContext';
import AuthGuard from '../contexts/AuthGuard';
import { SubscriptionProvider } from '../contexts/SubscriptionContext';

// Distributor Module Components
import DistributorDashboard from '../pages/modules/distributor/dashboard/DistributorDashboard';
import SubscriptionPlans from '../pages/modules/distributor/subscription/Plans';
import MySubscription from '../pages/modules/distributor/subscription/MySubscription';
import DistributorSupports from '../pages/modules/distributor/supports/DistributorSupports';
import DistributorFOS from '../pages/modules/distributor/fos/DistributorFOS';
import DistributorRetailers from '../pages/modules/distributor/retailers/DistributorRetailers';
import CollectRetailerOutstanding from '../pages/modules/distributor/collect-outstanding/CollectRetailerOutstanding';
import CollectFOSCollection from '../pages/modules/distributor/collect-outstanding/CollectFOSCollection';
import RetailerLedger from '../pages/modules/distributor/ledger/RetailerLedger';
import FOSCollectionHistory from '../pages/modules/distributor/collect-outstanding/FOSCollectionHistory';
import CollectionReports from '../pages/modules/distributor/reports/CollectionReports';
import RetailerCollectionReports from '../pages/modules/distributor/reports/RetailerCollectionReports';
import FOSCollectionReports from '../pages/modules/distributor/reports/FOSCollectionReports';
import LedgerReports from '../pages/modules/distributor/reports/LedgerReports';
import PaymentGatewayConfig from '../pages/modules/distributor/config/PaymentGatewayConfig';
import OutstandingUpload from '../pages/modules/distributor/upload/OutstandingUpload';
import PortalLoginConfig from '../pages/modules/distributor/config/PortalLoginConfig';
import DistributorOrders from '../pages/modules/distributor/orders/DistributorOrders';
import DistributorVPAWhitelist from '../pages/modules/distributor/vpa-whitelist/DistributorVPAWhitelist';
import DistributorBeats from '../pages/modules/distributor/beats/DistributorBeats';
import UPIPayments from '../pages/modules/distributor/upi-payments/UPIPayments';
import OutstandingRequests from '../pages/modules/distributor/outstanding-requests/OutstandingRequests';

const DistributorRoutes = () => {
  const { logout } = useAuth();

  return (
    <AuthGuard>
      <SubscriptionProvider>
        <Routes>
          <Route element={<DistributorLayout onLogout={logout} />}>
          <Route path="/" element={<Navigate to="/distributor/dashboard" replace />} />
          <Route path="/distributor" element={<Navigate to="/distributor/dashboard" replace />} />

          {/* Subscription Routes */}
          <Route path="/distributor/subscription/plans" element={<SubscriptionPlans />} />
          <Route path="/distributor/subscription/my-subscription" element={<MySubscription />} />

          {/* Distributor Module Routes */}
          <Route path="/distributor/dashboard" element={<DistributorDashboard />} />
        <Route path="/distributor/supports" element={<DistributorSupports />} />
        <Route path="/distributor/fos" element={<DistributorFOS />} />
        <Route path="/distributor/retailers" element={<DistributorRetailers />} />
        <Route path="/distributor/collect/retailer-outstanding" element={<CollectRetailerOutstanding />} />
        <Route path="/distributor/ledger/retailer/:retailerId/:profileId" element={<RetailerLedger />} />
        <Route path="/distributor/collect/fos-collection" element={<CollectFOSCollection />} />
        <Route path="/distributor/collect/fos-collection/:profileId/:fosId" element={<FOSCollectionHistory />} />
        <Route path="/distributor/reports/ledger" element={<LedgerReports />} />
        <Route path="/distributor/reports/collection" element={<CollectionReports />} />
        <Route path="/distributor/reports/retailer-collection" element={<RetailerCollectionReports />} />
        <Route path="/distributor/reports/fos-collection" element={<FOSCollectionReports />} />
        <Route path="/distributor/config/payment-gateway" element={<PaymentGatewayConfig />} />
        <Route path="/distributor/upload/outstanding" element={<OutstandingUpload />} />
        <Route path="/distributor/config/portal-login" element={<PortalLoginConfig />} />
        <Route path="/distributor/orders" element={<DistributorOrders />} />
        <Route path="/distributor/vpa-whitelist" element={<DistributorVPAWhitelist />} />
        <Route path="/distributor/beats" element={<DistributorBeats />} />
        <Route path="/distributor/upi-payments" element={<UPIPayments />} />
        <Route path="/distributor/outstanding-requests" element={<OutstandingRequests />} />
        
          <Route path="*" element={<Navigate to="/distributor/dashboard" replace />} />
          </Route>
        </Routes>
      </SubscriptionProvider>
    </AuthGuard>
  );
};

export default DistributorRoutes;